function ProfileSettingsIcon({ white = false }: { white?: boolean }) {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_2200_11020)">
				<g mask="url(#mask0_2200_11020)">
					<path
						d="M12.0023 8.31248C9.9658 8.31248 8.31482 9.96342 8.31482 12C8.31482 14.0365 9.9658 15.6875 12.0023 15.6875C14.0389 15.6875 15.6898 14.0365 15.6898 12C15.6898 9.96342 14.0389 8.31248 12.0023 8.31248ZM22.3524 9.36858L21.354 10.1905C20.2152 11.128 20.2152 12.8719 21.354 13.8095L22.3524 14.6314C22.7062 14.9227 22.7976 15.427 22.5685 15.8239L20.597 19.2385C20.3679 19.6354 19.8854 19.8085 19.4563 19.6477L18.2452 19.194C16.8639 18.6765 15.3536 19.5485 15.1111 21.0035L14.8985 22.2791C14.8232 22.7311 14.432 23.0625 13.9738 23.0625H10.0309C9.57261 23.0625 9.18149 22.7311 9.10616 22.2791L8.89353 21.0035C8.65105 19.5485 7.14078 18.6765 5.75943 19.194L4.54846 19.6477C4.11927 19.8085 3.63679 19.6354 3.40761 19.2385L1.43619 15.8239C1.20707 15.427 1.29843 14.9227 1.65224 14.6314L2.65068 13.8095C3.7895 12.8719 3.7895 11.128 2.65068 10.1905L1.65224 9.36858C1.29843 9.0773 1.20707 8.57292 1.43619 8.17603L3.40761 4.76142C3.63679 4.36453 4.11927 4.19147 4.54846 4.35225L5.75943 4.80591C7.14078 5.32341 8.65105 4.45148 8.89353 2.99644L9.10616 1.72083C9.18149 1.26881 9.57261 0.9375 10.0309 0.9375H13.9738C14.432 0.9375 14.8232 1.26881 14.8985 1.72083L15.1111 2.99644C15.3536 4.45148 16.8639 5.32341 18.2452 4.80591L19.4563 4.35225C19.8854 4.19147 20.3679 4.36453 20.597 4.76142L22.5685 8.17603C22.7976 8.57292 22.7062 9.0773 22.3524 9.36858Z"
						stroke={white ? "white" : "#4D5561"}
						strokeWidth="1.5"
						strokeMiterlimit="10"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</g>
			</g>
			<defs>
				<clipPath id="clip0_2200_11020">
					<rect width="24" height="24" fill={white ? "white" : "#4D5561"} />
				</clipPath>
			</defs>
		</svg>
	);
}

export default ProfileSettingsIcon;
